import { Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  styleUrls: ['./search-page.component.css'],
})
export class SearchPageComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>()

  /** Raw 'tab' query param, forwarded to <app-search-results>. */
  initialTab: string | null = null

  /** 'q', 'state' and 'lga' query params, e.g. /search?tab=sales&q=mattress&state=LAGOS from onboarding. */
  initialSearchText: string | null = null
  initialState: string | null = null
  initialLga: string | null = null

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.initialTab = params['tab'] ?? null
      this.initialSearchText = params['q'] ?? null
      this.initialState = params['state'] ?? null
      this.initialLga = params['lga'] ?? null
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }
}
